import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CardContext } from "../../../store/CardContext";
import { RiDirectionLine } from "react-icons/ri";
import phn from "../../../../assests/img/phoneicon.svg";
import mail from "../../../../assests/img/emailicon.svg";
import loc from "../../../../assests/img/loactionicon.svg";
import moreIcon from "../../../../assests/img/more_icon.svg"; // Assuming you have this SVG imported

function ContactCardDigit({ card, preview, Highlightcolor, Textcolor, Iconcolor, BtIColor }) {
  const [cardData] = useContext(CardContext);
  const { personalDetails, contactDetails } = cardData;
  const iconColor = BtIColor ? BtIColor : (Textcolor ? Textcolor : "black");

  const shareMail = (e) => {
    window.location = `mailto:${personalDetails?.email}`;
    e.preventDefault();
  };
  const shareMail2 = (e) => {
    window.location = `mailto:${card?.secondaryEmail}`;
    e.preventDefault();
  };


  return (
    <div className="mb-10 p-2">
      <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium" style={{ borderBottom: `1px solid ${Textcolor ? Textcolor : "black"}` }}>
        <div
          className="bg-no-repeat bg-right bg-center-y"
          style={{
            // Remove backgroundImage if using inline SVG
            // backgroundImage: `url(${moreIcon})`,
          }}
        >
          {/* Inline SVG for More Icon */}
          <svg width="13" className="absolute right-3 top-1/2 transform -translate-y-1/2 " height="13" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L1 9" stroke={iconColor} stroke-linecap="round" stroke-linejoin="round" />
          </svg>

          <Link
            to={preview ? `tel:+${personalDetails?.phone}` : ""}
            className="flex items-center gap-2"
          >
            <svg
              width="30"
              height="30"
              viewBox="0 0 20 20"
              fill="none"
              className="mr-2 p-2"
              style={{ backgroundColor: Iconcolor || "", borderRadius: "6px" }} // Set background color based on Iconcolor
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.7143 0.713867H4.28575C3.49677 0.713867 2.85718 1.35346 2.85718 2.14244V17.8567C2.85718 18.6457 3.49677 19.2853 4.28575 19.2853H15.7143C16.5033 19.2853 17.1429 18.6457 17.1429 17.8567V2.14244C17.1429 1.35346 16.5033 0.713867 15.7143 0.713867Z"
                stroke={iconColor} // Stroke color based on BtIColor
                strokeWidth="1.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.92896 15.7139H11.0718"
                stroke={iconColor} // Same stroke color for this path
                strokeWidth="1.42857"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <div className="flex flex-col">
              <span style={{ color: Textcolor || "black" }}>
                +{personalDetails?.phone || "123 456 7890"}
              </span>
              {card?.secondaryPhone && (
                <Link
                  style={{ color: Textcolor || "" }}
                  to={preview ? `tel:+${card.secondaryPhone}` : ""}
                >
                  +{card.secondaryPhone}
                </Link>
              )}
            </div>
          </Link>
        </div>
      </div>

      <div className="relative flex items-center gap-2 py-2.5 text-sm font-medium" style={{ borderBottom: `1px solid ${Textcolor ? Textcolor : "black"}` }}>
        <div
          className=""
          style={{
            // Remove backgroundImage if using inline SVG
            // backgroundImage: `url(${moreIcon})`,
          }}
        >
          {/* Inline SVG for More Icon */}
          <svg width="13" className="absolute right-3 top-1/2 transform -translate-y-1/2 " height="13" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L1 9" stroke={iconColor} stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div
            className=""

          >
            <Link
              onClick={preview ? shareMail : ""}
              className="flex items-center gap-2 py-2.5 text-sm font-medium "
            >
              <svg
                width="30"
                height="30"
                style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}`, borderRadius: "6px" }}
                className="mr-2 p-2"
                viewBox="0 0 20 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.8572 1.5H2.14293C1.35395 1.5 0.714355 2.13959 0.714355 2.92857V15.0714C0.714355 15.8604 1.35395 16.5 2.14293 16.5H17.8572C18.6462 16.5 19.2858 15.8604 19.2858 15.0714V2.92857C19.2858 2.13959 18.6462 1.5 17.8572 1.5Z"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M0.714355 3.28613L9.08578 10.429C9.34248 10.6428 9.66599 10.7599 10.0001 10.7599C10.3341 10.7599 10.6577 10.6428 10.9144 10.429L19.2858 3.28613"
                  stroke={BtIColor ? BtIColor : "#888888"}
                  stroke-width="1.42857"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <div className="flex-col flex">
                <span style={{ color: `${Textcolor ? Textcolor : "black"}` }}>
                  {personalDetails?.email || "john@example.com"}

                </span>
                {card?.secondaryEmail ? (
                  <Link
                    style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}
                    onClick={preview ? shareMail2 : ""}
                  >
                    {card?.secondaryEmail}
                  </Link>
                ) : (
                  ""
                )}
              </div>
            </Link>


          </div>
        </div>
      </div>

      {card?.address && (
        <div className="addressContainer mt-2 flex flex-col">
          <svg width="13" className="absolute right-3 top-1/2 transform -translate-y-1/2 " height="13" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L5 5L1 9" stroke={iconColor} stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <div className="flex items-center mb-2 w-full">
            <svg style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }} width="30" className="mr-2 p-2 rounded-[6px]"
              height="30" viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"   >
              <path d="M14.4284 7.14342C14.4284 10.7006 7.99986 19.2863 7.99986 19.2863C7.99986 19.2863 1.57129 10.7006 1.57129 7.14342C1.57129 5.43845 2.24858 3.80332 3.45417 2.59773C4.65976 1.39214 6.2949 0.714844 7.99986 0.714844C9.70482 0.714844 11.34 1.39214 12.5455 2.59773C13.7511 3.80332 14.4284 5.43845 14.4284 7.14342V7.14342Z" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M7.99955 9.28669C9.18301 9.28669 10.1424 8.3273 10.1424 7.14383C10.1424 5.96037 9.18301 5.00098 7.99955 5.00098C6.81608 5.00098 5.85669 5.96037 5.85669 7.14383C5.85669 8.3273 6.81608 9.28669 7.99955 9.28669Z" stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            <span className="w-[75%] ml-2" style={{ color: Textcolor || "black" }}>
              {card?.address}
            </span>
          </div>

          {card?.locationUrl && (
            <Link
              to={preview ? card?.locationUrl : "#"}
              target={preview ? "_blank" : ""}
              className="w-full"
            >
              <button
                // onClick={onClick}
                className="w-full h-[44px] py-2 px-4 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300 disabled:bg-gray-400 disabled:cursor-not-allowed"
                style={{
                  backgroundColor: Highlightcolor || "black",
                  color: Textcolor || "black",
                }}
              >
                <RiDirectionLine
                  className="mr-2"
                  size={18}
                  style={{ color: Textcolor || "black" }}
                />
                <span className="font-medium text-[12px]" style={{ color: Textcolor || "black" }}>
                  Directions
                </span>
              </button>
            </Link>
          )}
        </div>
      )}
      {/* {contactDetails?.locationUrl ? (
     <div
     className="bg-no-repeat bg-right-top  mt-4"
     style={{ backgroundImage: `url(${moreIcon})`  }}
   >
     <Link
       to={preview ? contactDetails?.locationUrl : ""}
       target={preview ? "_blank" : ""}
       className="block  pb-3" // Ensures the button fills the entire Link area
       style={{ textDecoration: 'none' }} // Optional: Removes underline
     >
       <div className="flex items-center gap-2 py-2.5 text-sm font-medium ">
       <svg    style={{ backgroundColor: `${Iconcolor ? Iconcolor : ""}` }}   width="30"    className="mr-2 p-2"
  height="30"  viewBox="0 0 16 20" fill="none" xmlns="http://www.w3.org/2000/svg"   >
<path d="M14.4284 7.14342C14.4284 10.7006 7.99986 19.2863 7.99986 19.2863C7.99986 19.2863 1.57129 10.7006 1.57129 7.14342C1.57129 5.43845 2.24858 3.80332 3.45417 2.59773C4.65976 1.39214 6.2949 0.714844 7.99986 0.714844C9.70482 0.714844 11.34 1.39214 12.5455 2.59773C13.7511 3.80332 14.4284 5.43845 14.4284 7.14342V7.14342Z"   stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M7.99955 9.28669C9.18301 9.28669 10.1424 8.3273 10.1424 7.14383C10.1424 5.96037 9.18301 5.00098 7.99955 5.00098C6.81608 5.00098 5.85669 5.96037 5.85669 7.14383C5.85669 8.3273 6.81608 9.28669 7.99955 9.28669Z"   stroke={BtIColor ? BtIColor : "#888888"} stroke-width="1.42857" stroke-linecap="round" stroke-linejoin="round"/>
</svg>


         <span style={{color: `${Textcolor ? Textcolor : "black"}`}}>{contactDetails?.address || "2709 Hwy 51, Janesville"}</span>
       </div>
   
       <div
         className="w-full h-[44px] py-2 px-4 mt-3 rounded-md flex items-center justify-center hover:bg-gray-800 transition-colors duration-300"
         style={{
           backgroundColor: Highlightcolor || "black",
           color: Textcolor || "white",
         }}
       >
         <RiDirectionLine className="mr-2" size={18} />
         <span style={{color: `${Textcolor ? Textcolor : "black"}`}} className="font-medium text-xs">Directions</span>
       </div>
     </Link>
   </div>
   
      ) : (
        <div
          className="bg-no-repeat bg-right-top"
          style={{ backgroundImage: `url(${moreIcon})` }}
        >
          <Link className="flex items-center gap-2 py-2.5 text-sm font-medium ">
            <img src={loc} alt="Location" className="mr-2" />
           
          </Link>
        </div>
      )} */}
    </div>
  );
}

export default ContactCardDigit;
